import { Utils } from 'versafleet-core';
import * as Sentry from '@sentry/browser';

const { request, convertDataToParams } = Utils.RequestHelper;

function requestCustomFieldGroup() {
  return {
    type: 'REQUEST_CUSTOM_FIELD_GROUP',
  };
}

function receiveCustomFieldGroup(customFieldGroup) {
  return {
    type: 'RECEIVE_CUSTOM_FIELD_GROUP',
    customFieldGroup,
  };
}

function requestCustomFieldGroups() {
  return {
    type: 'REQUEST_CUSTOM_FIELD_GROUPS',
  };
}

function receiveCustomFieldGroups(customFieldGroups) {
  return {
    type: 'RECEIVE_CUSTOM_FIELD_GROUPS',
    customFieldGroups,
  };
}

function receiveOptionCustomFieldGroups(customFieldGroups) {
  return {
    type: 'RECEIVE_OPTION_CUSTOM_FIELD_GROUPS',
    customFieldGroups,
  };
}

function receiveCustomFieldDescription(customFieldDescription) {
  return {
    type: 'RECEIVE_CUSTOM_FIELD_DESCRIPTION',
    customFieldDescription,
  };
}

function fetch(id) {
  return (dispatch) => {
    dispatch(requestCustomFieldGroup());
    request(`/custom_field_groups/${id}`, {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveCustomFieldGroup(result.custom_field_group));
        return result;
      })
      .catch((error) => { Sentry.captureException(error); });
  };
}

function fetchList(query) {
  return (dispatch) => {
    dispatch(requestCustomFieldGroups());
    request(`/custom_field_groups${convertDataToParams(query)}`, {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveCustomFieldGroups(result.custom_field_groups));
        return result;
      })
      .catch((error) => { Sentry.captureException(error); });
  };
}

function fetchOptionCustomFieldGroupList() {
  return (dispatch) => {
    request('/custom_field_groups', {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveOptionCustomFieldGroups(result.custom_field_groups));
        return result;
      })
      .catch((error) => { Sentry.captureException(error); });
  };
}

function fetchCustomFieldDescription(id, filter = {}) {
  return async (dispatch) => {
    const queryString = convertDataToParams({ ...filter });
    const result = await request(`/custom_field_descriptions/${id}${queryString}`, {
      method: 'GET',
    });
    dispatch(receiveCustomFieldDescription(result.custom_field_description));
  };
}

export default {
  fetch,
  fetchList,
  fetchOptionCustomFieldGroupList,
  fetchCustomFieldDescription,
};
